module.exports = __webpack_public_path__ + "img/128.8.849cd114.png";